<template>
  <div class="back-btn" type="link" @click="handleBack">
    <SvgIcon name="left" size="18px" />{{ text }}
  </div>
</template>

<script setup lang="ts">
import SvgIcon from '../SvgIcon/index.vue'

interface Props {
  text?: string
}

withDefaults(defineProps<Props>(), {
  text: '返回',
})

const emit = defineEmits<{
  (e: 'back'): void
}>()

const handleBack = () => {
  emit('back')
}
</script>

<style lang="less" scoped>
.back-btn {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 0;
  font-size: 14px;
  line-height: 1.3;
  color: var(--functional-red-medium-6);
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

// 响应式布局
@media screen and (max-width: 576px) {
  .header {
    margin-bottom: 24px;
  }
}
</style>
